import React from 'react';

import ValidateEmailContainer from './ValidateEmailContainer';
import ValidateEmailPage from './ValidateEmailPage';

const ValidateEmail: React.FC = () => (
    <ValidateEmailContainer.Provider>
        <ValidateEmailPage />
    </ValidateEmailContainer.Provider>
);

export default ValidateEmail;
